// extracted by mini-css-extract-plugin
export default {"submitUserButton":"SignupUser_submitUserButton__GQm3A"};